import React from 'react';

export default function VideoBackground({ 
  src, 
  poster, 
  overlayOpacity = "bg-black/40", 
  className = "", 
  videoPosition = "object-center" 
}) {
  return (
    <div className={`absolute inset-0 overflow-hidden bg-olive-dark ${className}`}>
      {/* 
        Video: z-0
        Handles both desktop and mobile video playback
      */}
      <video 
        autoPlay 
        muted 
        loop 
        playsInline 
        preload="auto" 
        poster={poster} 
        className={`absolute inset-0 w-full h-full object-cover ${videoPosition} z-0`}
      >
        <source src={src} type="video/mp4" />
        <source src={src} type="video/quicktime" />
      </video>

      {/* 
        Overlay: z-10
        Ensures it sits between video and text content
      */}
      <div className={`absolute inset-0 z-10 ${overlayOpacity}`}></div>
    </div>
  );
}